require('./mortgageRequestCover.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

const MortgageRequestCover = props => {
    const { extraClass, children, size } = props;
    const coverClassName = classNames('mortgage-request-cover', {
        [`mortgage-request-cover--${extraClass}`]: extraClass,
        [`mortgage-request-cover--${size}`]: size
    });

    return (
        <div className={coverClassName}>
            <div className="mortgage-request-cover__content">
                {children}
            </div>
        </div>
    );
};

MortgageRequestCover.propTypes = {
    extraClass: PropTypes.string,
    size: PropTypes.string,
    children: PropTypes.any,

    video_src: PropTypes.string,
    video_type: PropTypes.string
};

MortgageRequestCover.defaultProps = {
    size: 'default'
};

module.exports = MortgageRequestCover;